















































































































































































































































































































































































































































































































































import Vue from 'vue';
import moment, { Moment } from 'moment';
import axios from 'axios';
import { P } from 'vue-long-click';
import { get } from 'lodash';
import { preventDefault } from '@fullcalendar/common';
import { getUnixTime } from 'date-fns';

import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoAlert from '../../Molecules/co-alert/CoAlert.vue';
import CoFormGroup from '../../Molecules/co-form-group/CoFormGroup.vue';
import CoCheckbox from '../../Atoms/co-checkbox/CoCheckbox.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoModal from '../co-modal/CoModal.vue';

class BookingCandidate {
    constructor(
        public resource: object,
        public start: Date, // 00:00
        public end: Date,
        public showResourceSelector: boolean
    ) {}
}

interface bookingRequest {
    start: number;
    end: number;
    resourceid: string;
    for: string;
    couponIDs: string[];
    upgrades: object[];
}

interface createBookingRequest {
    start: number;
    end: number;
    resourceid: string;
    for: string;
    couponIDs: string[];

    overridePrice: boolean;
    overridePriceInCents: number;

    bookingTitle: string;
    bookingNotes: string;
    upgrades: object[];
}

export default {
    name: 'CoBookingCheckoutForAdminV2',
    components: {
        CoButton,
        CoAlert,
        CoFormGroup,
        CoCheckbox,
        CoText,
        CoModal,
    },
    props: {
        bookingCandidate: {
            type: Object as () => BookingCandidate,
            required: true,
        },
    },
    data() {
        return {
            booking: {
                start: moment(this.bookingCandidate.start).format('YYYY-MM-DD'),
                end: moment(this.bookingCandidate.end).format('YYYY-MM-DD'),
                startTime: moment(this.bookingCandidate.start).format('HH:mm'),
                endTime: moment(this.bookingCandidate.end).format('HH:mm'),
                resource: this.bookingCandidate.resource,
                user: null,
                overwritePrice: false,
            },
            overwritePriceInEuro: 0,
            me: this.$store.state.me,
            forUser: null,

            loading: false,
            success: false,
            checkToObject: null,
            error: false,
            bookingTimes: {},

            priceSum: {
                sum: 0.0, // sum of all prices
                usedCredits: 0,
                leftCredits: 0,
                total: 0.0,
            },
            defaultPrice: null,

            listWeekdays: [],
            sameTime: false,
            taxRate: null,
            taxRates: [],
            loadingTaxRate: false,

            timeError: '',
            requestedWeekday: 0,
            weekdays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            bookingPrice: null,
            bookingPriceLoading: false,

            isSlotExoustedCheckLoading: false,
            isSlotExousted: false,
            bookResourceAnyway: false, // if the slot is exousted, admin can still book the resource if this is true
            isBillingTurnedOn: this.$store.state.billingTurnedOn,

            upgrades: [],
        };
    },
    computed: {
        allUpgrades() {
            if (!this.bookingCandidate.resource.Upgrades) return null;
            let upgrades = this.bookingCandidate.resource.Upgrades;
            upgrades = upgrades.map(
                (item) => ({
                    ...item,
                    TaxRate: this.taxRates.find((t) => t.ID === item.TaxRateID)
                        ? this.taxRates.find((t) => t.ID === item.TaxRateID)
                        : null,
                }),
                this.taxRates
            );

            return upgrades;
        },
        bookingPricePreviewDetailed() {
            const result = {
                Items: [],
                TaxRates: [],
                Subtotal: 0,
                TaxTotal: 0,
                Total: 0,
            };

            if (!this.bookingPrice || !this.bookingPrice.Items) {
                return result;
            }

            this.bookingPrice.Items.forEach((element) => {
                const resource = {
                    name: this.idToNames[element.ResourceID],
                    quantity: element.Quantity,
                    tax: '',
                    displayprice: 0,
                    net: 0,
                    gross: 0,
                };

                const taxPercentage = element.TaxPercentage ? element.TaxPercentage : 0;
                resource.tax = `${taxPercentage}%`;
                if (element.TaxRateName) {
                    resource.tax += ` ${element.TaxRateName}`;
                }

                resource.displayprice = element.PriceInCentsBeforeCredits ? element.PriceInCentsBeforeCredits : 0;
                resource.net = element.PriceInCentsBeforeCreditsNet ? element.PriceInCentsBeforeCreditsNet : 0;
                resource.gross = element.PriceInCentsBeforeCreditsGross ? element.PriceInCentsBeforeCreditsGross : 0;

                result.Items.push(resource);

                if (element.CreditsInCents) {
                    const credits = {
                        name: `↳${this.$t('labels.credits')}`,
                        quantity: '',
                        tax: '',
                        displayprice: 0,
                        net: 0,
                        gross: 0,
                    };

                    credits.displayprice = -(element.CreditsInCents ? element.CreditsInCents : 0);
                    credits.net = -(element.CreditsInCentsNet ? element.CreditsInCentsNet : 0);
                    credits.gross = -(element.CreditsInCentsGross ? element.CreditsInCentsGross : 0);

                    result.Items.push(credits);
                }

                if (element.DiscountInCents) {
                    const discount = {
                        name: `↳${this.$t('labels.couponcode')} "${element.PromoCodeName}"`,
                        quantity: '',
                        tax: '',
                        displayprice: 0,
                        net: 0,
                        gross: 0,
                    };

                    discount.displayprice = -(element.DiscountInCents ? element.DiscountInCents : 0);
                    discount.net = -(element.DiscountInCentsNet ? element.DiscountInCentsNet : 0);
                    discount.gross = -(element.DiscountInCentsGross ? element.DiscountInCentsGross : 0);

                    result.Items.push(discount);
                }
            });

            result.Subtotal = this.bookingPrice.PriceInCentsNet ? this.bookingPrice.PriceInCentsNet : 0;
            result.Total = this.bookingPrice.PriceInCentsGross ? this.bookingPrice.PriceInCentsGross : 0;
            result.TaxTotal = result.Total - result.Subtotal;

            const taxRates = {};

            this.bookingPrice.Items.forEach((element) => {
                const tax = {
                    name: element.TaxRateName,
                    quantity: '',
                    tax: `${element.TaxPercentage}%`,
                    displayprice: element.TaxInCents,
                    net: 0,
                    gross: 0,
                };

                const existingTaxRate = taxRates[`${element.TaxRateName}-${element.TaxPercentage}`];
                if (existingTaxRate) {
                    tax.displayprice += existingTaxRate.displayprice;
                }

                taxRates[`${element.TaxRateName}-${element.TaxPercentage}`] = tax;
            });

            for (const k in taxRates) {
                result.TaxRates.push(taxRates[k]);
            }
            return result;
        },
        bookingPricePreview() {
            if (!this.bookingPrice) return [];

            const net = this.bookingPrice.PriceInCentsNet ? this.bookingPrice.PriceInCentsNet : 0;
            const gross = this.bookingPrice.PriceInCentsGross ? this.bookingPrice.PriceInCentsGross : 0;
            const taxamount = gross - net;
            const subtotal = {
                name: this.$t('labels.pricesubtotal'),
                amount: net,
            };

            const tax = {
                name: this.$t('labels.tax'),
                amount: taxamount,
            };

            const total = {
                name: this.$t('labels.total'),
                amount: gross,
            };

            const lines = [subtotal, tax, total];
            return lines;
        },
        creditsSummary() {
            if (!this.bookingPrice || !this.bookingPrice.Items || !this.booking) return null;

            const resourcePricePreview = this.bookingPrice.Items.find(
                (item) => item.ResourceID === this.bookingCandidate.resource.ID
            );
            if (!resourcePricePreview) return null;

            let used = resourcePricePreview.CreditsTimeUnitUsed ? resourcePricePreview.CreditsTimeUnitUsed : 0;
            let total = resourcePricePreview.CreditsTimeUnitTotal ? resourcePricePreview.CreditsTimeUnitTotal : 0;
            let before = resourcePricePreview.CreditsTimeUnitBeforeBooking
                ? resourcePricePreview.CreditsTimeUnitBeforeBooking
                : 0;
            let after = resourcePricePreview.CreditsTimeUnitAfterBooking
                ? resourcePricePreview.CreditsTimeUnitAfterBooking
                : 0;

            const cashCredits = resourcePricePreview.CashCredits;
            if (cashCredits) {
                used = resourcePricePreview.CashCreditsUsed ? resourcePricePreview.CashCreditsUsed : 0;
                total = resourcePricePreview.CashCreditsTotal ? resourcePricePreview.CashCreditsTotal : 0;
                before = resourcePricePreview.CashCreditsBeforeBooking
                    ? resourcePricePreview.CashCreditsBeforeBooking
                    : 0;
                after = resourcePricePreview.CashCreditsAfterBooking ? resourcePricePreview.CashCreditsAfterBooking : 0;
            }

            if (!used) {
                return null;
            }

            const res = [
                {
                    name: this.$t('labels.creditsbeforebooking'),
                    amount: before,
                },
                {
                    name: this.$t('labels.creditsused'),
                    amount: used,
                },

                {
                    name: this.$t('labels.creditsafterbooking'),
                    amount: after,
                },

                {
                    name: this.$t('labels.creditstotal'),
                    amount: total,
                },
            ];

            return {
                cashCredits,
                items: res,
            };
        },
        currencyChar() {
            if (!this.$store && !get(this.$store, 'state.space.Currency', '')) {
                return '€';
            }

            const currency = get(this.$store, 'state.space.Currency', '').toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        idToNames() {
            const idsnames = {};

            if (this.bookingCandidate.resource) {
                idsnames[this.bookingCandidate.resource.ID] = this.bookingCandidate.resource.Name;

                const upgrades = get(this.bookingCandidate.resource, 'Upgrades', []);
                upgrades.forEach((element) => {
                    idsnames[element.OriginalID] = element.Name;
                });
            }
            return idsnames;
        },
    },
    mounted() {
        this.$bvModal.show('makebookingmodal');

        this.booking = {
            start: moment(this.bookingCandidate.start).format('YYYY-MM-DD'),
            end: moment(this.bookingCandidate.end).format('YYYY-MM-DD'),
            startTime: moment(this.bookingCandidate.start).format('HH:mm'),
            endTime: moment(this.bookingCandidate.end).format('HH:mm'),
        };

        this.getTaxRate(this.bookingCandidate.resource.TaxRateID);
        this.getTaxRates();
    },
    watch: {
        booking(newVal, oldVal) {
            this.checkTimes();

            this.timeError = '';
        },
    },
    methods: {
        get,
        openPricePreviewDetails() {
            const el = this.$refs.pricepreview;
            if (el) {
                el.show();
            }
            return;
        },
        upgradesUpdate(id, val) {
            const result = val.reduce((acc, obj) => {
                const existing = acc.find((item) => item.ID === obj.ID);
                if (existing) {
                    existing.Quantity += 1;
                } else {
                    acc.push({ ID: obj.ID, Quantity: 1 });
                }
                return acc;
            }, []);

            const res = result[0];

            const existing = this.upgrades.find((item) => item.ID === res.ID);

            if (existing) {
                existing.Quantity = res.Quantity; // Increase quantity if exists
            } else {
                this.upgrades.push(res); // Add new item if not exists
            }

            this.previewBookingPrice();
        },
        deleteUpgrade(val) {
            this.upgrades = this.upgrades.filter((item) => val.ID !== item.ID);
            this.previewBookingPrice();
        },
        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/admin/tax-rate/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                });
        },
        handleOverwritePriceInEuroChange(value) {
            this.overwritePriceInEuro = value;
        },
        // convert cents to euro/dollar/...
        convertPrice(price: number) {
            if (!price) {
                return 0;
            }

            return (price / 100).toFixed(2);
        },

        // checkIfSlotCapacityExousted checks if the capacity of the slot is exousted to give a warning to admin
        checkIfSlotCapacityExousted() {
            this.isSlotExoustedCheckLoading = true;
            this.isSlotExousted = false;
            this.bookResourceAnyway = false;

            const req = {
                resourceid: this.bookingCandidate.resource.ID,
                start: this.getBookingStart().unix(),
                end: this.getBookingEnd().unix(),
            };

            axios({
                method: 'POST',
                url: `/booking/is-slot-exausted`,
                withCredentials: true,
                data: req,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const tmp = response.data;
                    if (response && response.data && response.data.IsExhausted) {
                        this.isSlotExousted = true;
                    } else {
                        this.isSlotExousted = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isSlotExoustedCheckLoading = false;
                });
        },

        previewBookingPrice() {
            this.checkIfSlotCapacityExousted();
            this.bookingPriceLoading = true;

            if (!this.isBillingTurnedOn) {
                this.bookingPrice = null;
                this.bookingPriceLoading = false;
                return;
            }

            const req: bookingRequest = {
                resourceid: this.bookingCandidate.resource.ID,
                start: this.getBookingStart().unix(),
                end: this.getBookingEnd().unix(),
                for: '',
                couponIDs: [], // TODO: add coupon
                upgrades: [],
            };

            if (this.upgrades) {
                req.upgrades = this.upgrades;
            }

            if (this.forUser) {
                req.for = this.forUser.ID;
            }

            axios({
                method: 'POST',
                url: `/admin/booking/preview2`,
                withCredentials: true,
                data: req,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.bookingPrice = response.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.bookingPriceLoading = false;
                });
        },

        checkTimes() {
            if (this.bookingTimes) {
                this.timeError = '';
                if (this.booking.startTime < this.bookingTimes.From || this.booking.startTime > this.bookingTimes.To) {
                    this.booking.startTime = this.bookingTimes.From;
                    this.timeError = `The booking times for this day are from ${this.bookingTimes.From} to ${this.bookingTimes.To}`;
                }
                if (this.booking.endTime > this.bookingTimes.To || this.booking.endTime < this.bookingTimes.From) {
                    this.booking.endTime = this.bookingTimes.To;
                    this.timeError = `The booking times for this day are from ${this.bookingTimes.From} to ${this.bookingTimes.To}`;
                }

                if (!this.getBookingStart().isBefore(this.getBookingEnd())) {
                    this.timeError = 'The start time must be before the end time';
                }
                if (this.timeError === '') {
                    this.previewBookingPrice();
                } else {
                    this.bookingPrice = null;
                }
            }
        },

        getBookingStart(): Moment | undefined {
            const timeStart = this.booking.startTime.split(':');
            const from = moment(this.booking.start);
            if (!from) {
                return undefined;
            }
            from.hours(parseInt(timeStart[0]));
            from.minutes(parseInt(timeStart[1]));

            return from;
        },

        getBookingEnd(): Moment | undefined {
            const timeEnd = this.booking.endTime.split(':');
            const to = moment(this.booking.end);
            if (!to) {
                return undefined;
            }
            to.hours(parseInt(timeEnd[0]));
            to.minutes(parseInt(timeEnd[1]));

            return to;
        },

        hideModals() {
            this.success = false;
            this.error = false;
            this.loading = false;
            this.$emit('hideModals');
            this.upgrades = [];
            setTimeout(() => {
                this.$bvModal.hide('makebookingmodal'), 200;
            });
        },
        selectUser(user) {
            this.forUser = user;
            this.booking.title = `${this.bookingCandidate.resource.Name} booking for ${user.Profile.Name}`;
            this.previewBookingPrice();
        },
        unselectUserFor() {
            this.forUser = null;
            this.booking.title = `${this.bookingCandidate.resource.Name} booking`;
            this.bookingPrice = null;
        },

        makeBooking() {
            // start loader
            this.loading = true;

            const req: createBookingRequest = {
                start: this.getBookingStart().unix(),
                end: this.getBookingEnd().unix(),
                resourceid: this.bookingCandidate.resource.ID,

                bookingTitle: this.booking.title,
                bookingNotes: '',
                couponIDs: this.booking.coupons,

                for: '',
                overridePrice: false,
                overridePriceInCents: 0,

                upgrades: this.upgrades,
            };

            if (this.forUser) {
                req.for = this.forUser.ID;
            }

            if (this.booking.overwritePrice) {
                req.overridePrice = true;
                req.overridePriceInCents = Number(this.overwritePriceInEuro * 100);
            }

            // add current day to time
            const data = JSON.stringify(req);

            axios({
                method: 'POST',
                url: '/admin/booking',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$emit('bookingCreated');
                    setTimeout(() => {
                        this.error = false;
                        this.success = true;
                        this.$emit('created');
                    }, 300);
                })
                .catch((error) => {
                    setTimeout(() => {
                        this.error = error.response.data;
                        this.success = false;
                    }, 300);
                });
        },

        getTaxRate(taxID) {
            axios({
                method: 'GET',
                url: `/space/tax/${taxID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRate = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
